import styles from "./KeycapHint.module.css";
import type { DetonateHintVariantProps } from "./types";

/** Pattern A: a physical keycap floating under the board. */
export default function KeycapHint({ input }: DetonateHintVariantProps) {
  return (
    <div className={styles.root} role="status">
      <span className={styles.key}>{input === "key" ? "SPACE" : "TAP"}</span>
      <span className={styles.label}>{input === "key" ? "を押して爆発" : "して爆発"}</span>
    </div>
  );
}
